/**
 * *Spis k dátumu* of a case (PRD-0075 R-D4) in the URL: the chosen day is the search param
 * `?asOf=YYYY-MM-DD`, so a link or a reload keeps it, and the case remembers it while the reader
 * moves between its pages. Pure, apart from that per-case memory of the open app.
 */
export const AS_OF_PARAM = 'asOf'

/** The day each case was last shown as of while the app is open; a case cleared back to now has none. */
const keptDays = new Map<string, string>()

export function keptAsOfDay(caseId: string): string | null {
  return keptDays.get(caseId) ?? null
}

export function keepAsOfDay(caseId: string, day: string | null): void {
  if (day) keptDays.set(caseId, day)
  else keptDays.delete(caseId)
}

/** The search params with `day` as the as-of day, or without one; the others stay as they are. */
export function withAsOfDay(params: URLSearchParams, day: string | null): URLSearchParams {
  const next = new URLSearchParams(params)
  if (day) next.set(AS_OF_PARAM, day)
  else next.delete(AS_OF_PARAM)
  return next
}
